import React from 'react';

export const GuidPageContext = React.createContext<any | null>(null);

export const useGuidPageContext = () => {
  const context = React.useContext(GuidPageContext);
  if (!context) throw new Error("useGuidPageContext can not be used outside it's provider");
  return context;
};
